module.exports = __webpack_public_path__ + "img/btn-login-base@2x.d72fdaa1.jpg";